<template>
  <div id="app">
      <Header></Header>
      <router-view></router-view>
      <Footer></Footer>
      <div class="scroll-top hvr-grow-shadow" @click="scrollTop" @mouseenter="isRed = true" @mouseleave="isRed = false">
          <img src="@/assets/img/top.png" alt="" v-if="!isRed">
          <img src="@/assets/img/top-hove.png" v-else alt="">
      </div>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

window.onscroll = function (e){
    if(document.documentElement.scrollTop > 300){
        document.querySelector('.scroll-top').style.display = 'block'
    } else {
        document.querySelector('.scroll-top').style.display = 'none'
    }
}


export default {
    name: 'app',
    data(){
        return{
            isRed: false
        }
    },
    components: {
        Footer,Header
    },
    methods: {
        scrollTop(){
            document.documentElement.scrollTop = 0
        }
    }
}

</script>

<style lang="scss" scoped>
.scroll-top{
    position: fixed;
    bottom: 50px;
    right: 50px;
    z-index: 999999;
    cursor: pointer;
    >img{
        width: 62px;
        height: 62px;
    }
}
</style>

